// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 3rem;
  transition: all 0.4s ease;
}

.navbar.scrolled {
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(191, 0, 255, 0.2);
  padding: 0.8rem 3rem;
}

.navbar-logo {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  cursor: pointer;
}

.navbar-logo img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 6px;
  filter: invert(1) sepia(1) hue-rotate(240deg) saturate(4);
}

.navbar-logo span {
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  background: linear-gradient(90deg, #fff, #bf00ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.navbar-links {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.navbar-links button {
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 0.9rem;
  letter-spacing: 0.08em;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: color 0.3s;
  text-transform: uppercase;
}

.navbar-links button:hover {
  color: #fff;
}

.navbar-links button.cta {
  border: 1px solid rgba(191,0,255,0.6);
  color: #bf00ff;
  border-radius: 2px;
  clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
}

.navbar-links button.cta:hover {
  background: rgba(191,0,255,0.15);
  color: #fff;
}

.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.burger span {
  display: block;
  width: 24px;
  height: 2px;
  background: #bf00ff;
  transition: all 0.3s;
}

@media (max-width: 768px) {
  .navbar { padding: 1rem 1.5rem; }
  .navbar.scrolled { padding: 0.7rem 1.5rem; }
  .burger { display: flex; }
  .navbar-links {
    display: none;
    position: absolute;
    top: 100%; left: 0; right: 0;
    flex-direction: column;
    background: rgba(0,0,0,0.95);
    backdrop-filter: blur(20px);
    padding: 1.5rem;
    border-bottom: 1px solid rgba(191,0,255,0.2);
    gap: 0.5rem;
  }
  .navbar-links.open { display: flex; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU,oBAAoB,EAAE;EAChC,mBAAmB,sBAAsB,EAAE;EAC3C,UAAU,aAAa,EAAE;EACzB;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,4CAA4C;IAC5C,WAAW;EACb;EACA,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0; left: 0; right: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.2rem 3rem;\n  transition: all 0.4s ease;\n}\n\n.navbar.scrolled {\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(191, 0, 255, 0.2);\n  padding: 0.8rem 3rem;\n}\n\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  cursor: pointer;\n}\n\n.navbar-logo img {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n  border-radius: 6px;\n  filter: invert(1) sepia(1) hue-rotate(240deg) saturate(4);\n}\n\n.navbar-logo span {\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  background: linear-gradient(90deg, #fff, #bf00ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.navbar-links {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.navbar-links button {\n  background: none;\n  border: none;\n  color: rgba(255,255,255,0.7);\n  font-size: 0.9rem;\n  letter-spacing: 0.08em;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  transition: color 0.3s;\n  text-transform: uppercase;\n}\n\n.navbar-links button:hover {\n  color: #fff;\n}\n\n.navbar-links button.cta {\n  border: 1px solid rgba(191,0,255,0.6);\n  color: #bf00ff;\n  border-radius: 2px;\n  clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);\n}\n\n.navbar-links button.cta:hover {\n  background: rgba(191,0,255,0.15);\n  color: #fff;\n}\n\n.burger {\n  display: none;\n  flex-direction: column;\n  gap: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.burger span {\n  display: block;\n  width: 24px;\n  height: 2px;\n  background: #bf00ff;\n  transition: all 0.3s;\n}\n\n@media (max-width: 768px) {\n  .navbar { padding: 1rem 1.5rem; }\n  .navbar.scrolled { padding: 0.7rem 1.5rem; }\n  .burger { display: flex; }\n  .navbar-links {\n    display: none;\n    position: absolute;\n    top: 100%; left: 0; right: 0;\n    flex-direction: column;\n    background: rgba(0,0,0,0.95);\n    backdrop-filter: blur(20px);\n    padding: 1.5rem;\n    border-bottom: 1px solid rgba(191,0,255,0.2);\n    gap: 0.5rem;\n  }\n  .navbar-links.open { display: flex; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
